import { CustomButton } from 'components/shared/CustomButton';
import { CustomDatePicker } from 'components/shared/CustomDatePicker';
import { FilterDataId } from 'features/reducers/filterdata/FilterData.Reducers';
import { useTypedDispatch } from 'features/reduxhooks/ReduxHooks';
import moment from 'moment';
import React, { useState } from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'
import { error } from 'toastr';
 
type PropsTypes = {
    statusList: Array<any>,
    isWantExport?: boolean | null,
    onClick(item: any): void;
    statusName?: any,
    onExport?: any,
    onFromDateChange(fromDate: string): void | any;
    onToDateChange(toDate: string): void | any;
    CreatedFromDateLabel?: string
    CreatedToDateLabel?: string
    splitCol?: number
}
 
const StatusStatsFilters = ({ statusList, isWantExport = true, onClick, statusName, onExport, onFromDateChange, onToDateChange, CreatedFromDateLabel, CreatedToDateLabel, splitCol = 4 }: PropsTypes) => {
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const dispatch = useTypedDispatch();
 
    const isSelected = (name: any) => {
        if (name == statusName) {
            return true;
        } else {
            return false;
        }
    }
 
    const handleFromDateChange = (value: any) => {
        onFromDateChange(value);
        setFromDate(value)
    }
 
    const handleToDateChange = (value: any) => {
        onToDateChange(value);
        setToDate(value)
    }
 
    const IconsForStats = (enumName: any) => {
        switch (enumName) {
            case "Open":
                return "bx-folder-open";
            case "InProgress":
                return "bx-loader";
            case "Completed":
                return "bx-task";
            case "Approved":
                return "bx-check-shield";
            case "Rejected":
                return "bx-x";
            case "All":
                return "bx-folder-open";
            case "Published":
                return "bx-task";
            case "UnPublished":
                return "bx-loader";
            case "Draft":
                return "bx-x";
            default:
                return "bx-info-circle";
        }
    }
 
    return (
        <React.Fragment>
            <Row>
                <Col xl={7} lg={12} md={12}>
                    <Row>
                        {(statusList || [])?.map((list: any, idx: number) => (
                            <Col md={splitCol} key={"_col_" + idx}>
                                <Card className={`mini-stats-wid cursor-pointer shadow-none`} onClick={() => {
                                    onClick(list.Id);
                                    dispatch(FilterDataId({ payload: 0, type: "OffsetStart" }));
                                }} style={{ borderRadius: "10px", borderBottom: isSelected(list.Name) ? "3px solid #1E4496" : "2px solid #FFF" }}>
                                    <CardBody className='p-1'>
                                        <div className="d-flex">
                                            <div className="flex-grow-1">
                                                <p className="text-muted fw-thin dofy-admin-font-xs mb-2">{list.Name} </p>
                                                <h4 className="m-0 text-dofy fw-bold">{list.StatsCount}</h4>
                                            </div>
                                            <div className="avatar-xs rounded-3 bg-light align-self-center mini-stat-icon shadow-sm">
                                                <span className="avatar-title rounded-circle bg-light">
                                                    <i className={`bx ${IconsForStats(list.EnumName)} font-size-22 text-dofy`} />
                                                </span>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Col>
                {isWantExport ? (<Col xl={5} lg={12} md={12} style={{ borderLeft: "2px solid #1E4496" }}>
                    <Card className='p-2 m-0 px-3 rounded-3 shadow-none '>
                        <CardBody className='p-0 m-0'>
                            <Row >
                                <Col xl={6} lg={6} md={6}> <CustomDatePicker
                                    label={CreatedFromDateLabel}
                                    value={moment(fromDate).format('YYYY-MM-DD')}
                                    onChange={(e: any) => handleFromDateChange(e.target.value)} id={"FromDate"} error={error} />
                                </Col>
                                <Col xl={6} lg={6} md={6}>
                                    <CustomDatePicker
                                        label={CreatedToDateLabel}
                                        value={moment(toDate).format('YYYY-MM-DD')}
                                        onChange={(e: any) => handleToDateChange(e.target.value)} id={"ToDate"} error={error}
                                        disabled={!fromDate} minValue={fromDate} />
                                </Col>
 
                            </Row>
                        </CardBody>
                    </Card>
                    <div className='d-flex justify-content-end my-3'>
                        <CustomButton type={"button"} btnClassName={"btn btn-danger mx-3 btn-sm"} iconClasssName={undefined} name={"Reset"} onClick={() => { handleFromDateChange(null); handleToDateChange(null); onClick(null) }} disabled={!(fromDate || toDate || statusName)} />
                        <CustomButton type={"button"} btnClassName={"btn btn-info btn-sm"} iconClasssName={"mdi mdi-microsoft-excel font-size-14 me-2"} name={"Export"} onClick={() => onExport()} />
                    </div>
                </Col>) : (<Col xl={5} lg={12} md={12} style={{ borderLeft: "2px solid #1E4496" }}>
                    <Card className='p-2 m-0 px-3 rounded-3 shadow-none '>
                        <CardBody className='p-0 m-0'>
                            <Row >
                                <Col xl={4} lg={6} md={6}> <CustomDatePicker
                                    label={CreatedFromDateLabel}
                                    value={moment(fromDate).format('YYYY-MM-DD')}
                                    onChange={(e: any) => handleFromDateChange(e.target.value)} id={"FromDate"} error={error} />
                                </Col>
                                <Col xl={4} lg={6} md={6}>
                                    <CustomDatePicker
                                        label={CreatedToDateLabel}
                                        value={moment(toDate).format('YYYY-MM-DD')}
                                        onChange={(e: any) => handleToDateChange(e.target.value)} id={"ToDate"} error={error}
                                        disabled={!fromDate} minValue={fromDate} />
                                </Col>
                                <Col xl={4} lg={6} md={6}>
                                    <div className='d-flex justify-content-end mt-5'>
                                        <CustomButton type={"button"} btnClassName={"btn btn-danger mx-1 p-2 btn-sm"} iconClasssName={undefined} name={"Reset"} onClick={() => { handleFromDateChange(null); handleToDateChange(null); onClick(null) }} disabled={!(fromDate || toDate || statusName)} />
                                    </div>
                                </Col>
 
                            </Row>
                        </CardBody>
                    </Card>
 
                </Col>)}
 
            </Row>
        </React.Fragment>
    )
}
 
export default StatusStatsFilters
 